import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";

export default function ProprietarStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField
        label="Nume complet"
        value={data.proprietarNume}
        onChange={update("proprietarNume")}
        placeholder="ex: Popescu Ion"
        required
        error={errors.proprietarNume}
      />
      <InputField
        label="Adresa de domiciliu"
        value={data.proprietarAdresa}
        onChange={update("proprietarAdresa")}
        placeholder="ex: Str. Exemplu nr. 1, București"
        required
        error={errors.proprietarAdresa}
      />
      <OptionalFields>
        <InputField
          label="CNP"
          value={data.proprietarCNP}
          onChange={update("proprietarCNP")}
          placeholder="ex: 1234567890123"
          half
          error={errors.proprietarCNP}
          helperText="Opțional — poți completa de mână pe document"
        />
        <InputField
          label="Serie și nr. CI"
          value={data.proprietarCI}
          onChange={update("proprietarCI")}
          placeholder="ex: RD 123456"
          half
          error={errors.proprietarCI}
          helperText="Opțional — poți completa de mână pe document"
        />
      </OptionalFields>
    </div>
  );
}
